import { CaptchaCallbackResult } from '@/sfe';

export interface IWholeMobileAndEmailResult {
  email: string;
  mobile_with_country: string;
}

// sendCodeMobile方法参数类型
export interface ISendCodeMobileParams {
  country_code: string | number;
  mobile: string;
  from: number;
  type: string;
  key_version: string;
  [key: string]: any;
}
interface IQQRes {
  ticket: string;
  randstr: string;
}
interface IGoogleRes {
  g_recaptcha_response: string;
}

export type AuthResContextType = IQQRes | IGoogleRes;

export enum ICaptchaTargetType {
  /**qq腾讯行为验证 */
  qqcaptcha = 3,
  /**google谷歌行为验证 */
  recaptcha = 4,
}
export enum ICodeTargetType {
  /**邮箱验证 */
  EMAIL = 1,
  /**手机验证 */
  Mobile = 2,
  /**google 2fa */
  Google2fa = 5,
}
interface ICaptchaAuthContext {
  target: {
    type: ICaptchaTargetType | null;
  };
  answer: {
    /**qq腾讯行为验证取值为回调返回值ticket字段，谷歌行为验证取值g_recaptcha_response */
    response: string | undefined;
    // qq腾讯行为验证的有 -- 取值为回调返回值randstr字段，google 的没有
    tencent_randstr?: string;
  };
}
interface ICodeAuthContext {
  // 1 - 邮箱验证； 2 - 手机验证
  target: {
    type: ICodeTargetType | null;
  };
}
// 子账号登录态下绑定子账号Google2fa
export interface ILoginSubAccount {
  from: 5;
  context: [
    {
      target: {
        // 1 - 邮箱验证； 2 - 手机验证
        type: ICodeTargetType | null;
        targetExt: {
          memberId: number;
        };
      };
    },
  ];
}

export type IAuthenticate = {
  // 修改子账号密码的业务场景下为7, v3/private/user/authenticate
  from: 7;
  context: [ICaptchaAuthContext, ICodeAuthContext];
};
// | ILoginSubAccount;
export interface IContext {
  target: {
    type: string;
    target: string;
    targetExt: null;
  };
  challenge: string;
  answer: null;
}
export interface IAuthenticateResult {
  context: IContext;
}

export interface ISendEmail {
  email: string;
  captchaData: CaptchaCallbackResult;
  cnt: number;
  from: 11;
}

export interface IVerifySubParms {
  loginName: string;
  member_type: string;
}
